const template = `<span><iframe ng-if="vm.url && vm.mapUrlsLoaded" src='{{vm.url}}' width="100%" height="100%" frameborder="0" id="mapFrame_{{vm.gisId}}" class="map-frame" allowfullscreen prevent-scroll></iframe></span>`;

/*@ngInject*/
module.exports = function () {
    return {
        scope: {
            gisId: '='
        },
        restrict: 'E',
        replace: true,
        template,
        require: 'ngModel',
        controllerAs: 'vm',
        bindToController: true,
        /*@ngInject*/
        controller: function ($sce, $rootScope) {
            let vm = this;
            vm.url = '';
            vm.mapUrlsLoaded = false;
            vm.rootscope = $rootScope;

            vm.$onInit = function() {
                const mapUrls = vm.rootscope.mapUrls;
                let hideUrls = mapUrls.roadElementPathUrl + ',' + mapUrls.roadElementObstacleUrl + ',' + mapUrls.objectUrl;

                vm.url = $sce.trustAsResourceUrl(mapUrls.mapUrl + '?init=[{"type":"filter","ids":['+ JSON.stringify(vm.gisId) + '], "url":' + JSON.stringify(mapUrls.routeUrl) + ', "zoomTo":true},{"type":"hide-layers","url":' + JSON.stringify(hideUrls) + '}]');
                vm.mapUrlsLoaded = true;
            };

        }
    }
};



/** WEBPACK FOOTER **
 ** ./app/shared/directives/routes/route-view-map.directive.js
 **/